import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserPreferences } from '../../types';

const initialState: UserPreferences = {
  theme: 'light',
  autoplay: true,
  defaultPlaylist: null,
  recentChannels: [],
  favorites: [],
  preferredQuality: undefined,
  preferredSubtitleLanguage: undefined,
  subtitlesEnabled: false,
  language: 'en',
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
      document.documentElement.classList.toggle('dark', action.payload === 'dark');
    },
    setAutoplay: (state, action: PayloadAction<boolean>) => {
      state.autoplay = action.payload;
    },
    setDefaultPlaylist: (state, action: PayloadAction<string | null>) => {
      state.defaultPlaylist = action.payload;
    },
    addToRecent: (state, action: PayloadAction<string>) => {
      if (!state.recentChannels.includes(action.payload)) {
        state.recentChannels = [action.payload, ...state.recentChannels].slice(0, 10);
      }
    },
    toggleFavorite: (state, action: PayloadAction<string>) => {
      const channelId = action.payload;
      const index = state.favorites.indexOf(channelId);
      if (index === -1) {
        state.favorites.push(channelId);
      } else {
        state.favorites.splice(index, 1);
      }
    },
    clearFavorites: (state) => {
      state.favorites = [];
    },
    setPreferredSubtitleLanguage: (state, action: PayloadAction<string | undefined>) => {
      state.preferredSubtitleLanguage = action.payload;
    },
    setSubtitlesEnabled: (state, action: PayloadAction<boolean>) => {
      state.subtitlesEnabled = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
  },
});

export const {
  setTheme,
  setAutoplay,
  setDefaultPlaylist,
  addToRecent,
  toggleFavorite,
  clearFavorites,
  setPreferredSubtitleLanguage,
  setSubtitlesEnabled,
  setLanguage,
} = preferencesSlice.actions;

export default preferencesSlice.reducer;
